import { render, staticRenderFns } from "./Chamador.vue?vue&type=template&id=ba13da3c&scoped=true&"
import script from "./Chamador.vue?vue&type=script&lang=js&"
export * from "./Chamador.vue?vue&type=script&lang=js&"
import style0 from "./Chamador.vue?vue&type=style&index=0&id=ba13da3c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba13da3c",
  null
  
)

export default component.exports